module.exports = __webpack_public_path__ + "images/application/signup-delivery-9a06c5f3.png";